import React from 'react'
import PropTypes from 'prop-types'
import {SortableContainer, SortableElement, SortableHandle} from 'react-sortable-hoc'
import './index.scss'
import {MenuOutlined} from '@ant-design/icons'

const DragHandle = SortableHandle(() => {
  return (
    <span className="drag-handle">
      <MenuOutlined />
    </span>
  )
})

const SortableListItem = SortableElement(({label, sortable, renderLabel, renderItem}) => {
  const dragHandle = sortable && <DragHandle />

  if (renderItem) {
    return renderItem(label, {dragHandle})
  }

  return (
    <div className="sortable-list-item">
      {dragHandle}
      <span>{renderLabel ? renderLabel(label) : label}</span>
    </div>
  )
})

const SortableList = SortableContainer(({labels, renderLabel, renderItem, sortable}) => {
  return (
    <div className="sortable-list">
      {labels.map((label, index) =>
        <SortableListItem
          key={`item-${index}`}
          index={index}
          label={label}
          sortable={sortable}
          renderLabel={renderLabel}
          renderItem={renderItem}
        />
      )}
    </div>
  )
})

const SortableListWrapper = ({labels, onUpdate, renderLabel, renderItem, sortable = true}) => {
  const onSortEnd = ({oldIndex, newIndex}) => {
    if (!sortable) return
    const rearrangedLabels = [...labels]
    rearrangedLabels.splice(oldIndex, 1)
    rearrangedLabels.splice(newIndex, 0, labels[oldIndex])
    onUpdate(rearrangedLabels)
  }

  return (
    <SortableList
      labels={labels}
      onSortEnd={onSortEnd}
      useDragHandle={true}
      sortable={sortable}
      renderLabel={renderLabel}
      renderItem={renderItem}
    />
  )
}

SortableListWrapper.propTypes = {
  labels: PropTypes.array.isRequired,
  onUpdate: PropTypes.func.isRequired,
  renderLabel: PropTypes.func,
  renderItem: PropTypes.func,
}

export default SortableListWrapper
